const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export function formatCurrency(value) {
  return currencyFormatter.format(value || 0);
}

export function formatWeight(grams) {
  if (grams >= 1000) {
    return `${(grams / 1000).toFixed(3)} kg`;
  }
  return `${grams.toFixed(0)} g`;
}

export function formatDateTime(date) {
  if (!date) return '--';
  const d = new Date(date);
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
